module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/contest_stats/nfl/survive/tds_yards-67e45d1b52fc3fd8eecee977e5c89ee4.svg";